import React from 'react';
import { Link } from 'react-router-dom';
import { useGallery } from '../../context/GalleryContext';

interface BreadcrumbProps {
    /** Section slug path whose trail is shown. */
    path: string[];
    /** Optional current item beyond the section (e.g. artwork title). When set, the
     *  section trail becomes a link back to the section. */
    trailing?: string;
    /** Colour scheme — dark tuned for the dark viewing room. */
    variant?: 'light' | 'dark';
}

// Breadcrumb trail from the config (uppercase, letter-spaced).
export const Breadcrumb = ({ path, trailing, variant = 'light' }: BreadcrumbProps) => {
    const { getBreadcrumb } = useGallery();
    const trail = getBreadcrumb(path).join(' — ');

    const c =
        variant === 'dark'
            ? { base: 'text-tone-600', link: 'text-tone-600 hover:text-white', current: 'text-tone-300' }
            : { base: 'text-tone-800', link: 'text-tone-800 hover:text-black', current: 'text-tone-900' };

    return (
        <nav aria-label="Breadcrumb" className={`text-eyebrow uppercase tracking-nav ${c.base}`}>
            {trailing ? (
                <>
                    <Link to={`/${path.join('/')}`} className={c.link}>
                        {trail}
                    </Link>
                    <span className={c.current}> — {trailing}</span>
                </>
            ) : (
                <span>{trail}</span>
            )}
        </nav>
    );
};
